/*
 * [Ref] - Denotes Pseudo Code Reference  
 *  
 * This component is the WO parts component. The component displays the items which are placed using a particulart WO.
 * 
 * App Name: SDI-Walmart
 * Author: Aparna K
 * Created Date: 05/22/2023
 */

/**
 * WAL-1034_PC_11
 * */

import React, { Component } from 'react';
/*
 * CookieService is used for the Usage of the local database values in the component. 
 * The Local database is used for maintaining the login user falgs 
 * 
 * */
import * as CookieService from '../CookieService';
import { withTranslation, Trans } from 'react-i18next'
class WOPartsComponent extends Component {
    /**
     * WAL-1034_PC_12
     * Declare a “constructor” method with “props” as its parameters.
     */
    constructor(props) {
        super(props);
        this.state = {
            WO_Parts: localStorage.getItem("WO_Parts") != null && localStorage.getItem("WO_Parts") != undefined && localStorage.getItem("WO_Parts") != "" ? JSON.parse(localStorage.getItem("WO_Parts")) : [] //Bug :3618
        }
    }
    componentDidMount() {
        if (this.state.WO_Parts == undefined || this.state.WO_Parts == null) {
            this.setState({
                WO_Parts: localStorage.getItem("WO_Parts") != null && localStorage.getItem("WO_Parts") != undefined && localStorage.getItem("WO_Parts") != "" ? JSON.parse(localStorage.getItem("WO_Parts")) : [] })
        }
    }
    /***
     * WAL-1034_PC_14
     * */
    bindWO_Parts = () => {
        let WO_Parts = JSON.parse(localStorage.getItem("WO_Parts")) //CookieService.getLocalStorageValues("WO_Parts")
        if (WO_Parts != null && WO_Parts != undefined) {
            if (WO_Parts.length > 0) {
                return WO_Parts.map((val, ind) => {
                    //   ;
                    //alert(val.ISA_ORIG_URL)
                    let imagePath = "";
                    if (val.ISA_ORIG_URL == "Images\noimage_new.png" || val.ISA_ORIG_URL == "zeus_default") {
                        imagePath = `/Images/noimage_new.png`;
                    }
                    else if (val.ISA_ORIG_URL) {
                        val.ISA_ORIG_URL = val.ISA_ORIG_URL.replace('\\', '/');
                        if (val.ISA_ORIG_URL.toLowerCase().indexOf("http") >= 0) {
                            imagePath = val.ISA_ORIG_URL;
                        } else {
                            imagePath = val.ISA_ORIG_URL.lastIndexOf(`/`) >= 0 ? val.ISA_ORIG_URL.substring(val.ISA_ORIG_URL.lastIndexOf("/") + 1, val.ISA_ORIG_URL.length) : "noimage_new.png";
                            if (imagePath) {
                                imagePath = `Images/${imagePath}`;
                            }
                        }
                    }
                    else {
                        imagePath = `/Images/noimage_new.png`;
                    }
                    return (
                        <div className="order-card px-3 py-3 mb-3">
                            <div className="d-flex">
                                <div className="d-block">
                                    <img className="custom-img-style" src={imagePath} onError={(e) => { e.target.src = "/Images/noimage_new.png" }}  alt="No image" altSrc="/Images/noimage_new.png" />
                                </div>
                                <div className="d-block ml-3">
                                    <h5 className="font-14 font-medium"><Trans>MFG</Trans>: {val.ISA_MFG_FREEFORM}</h5>
                                    <span className="d-block">
                                        <span className="font-14 font-medium custom-parts-spec-color"><Trans>MFG Part#</Trans>:</span> <span className="font-14 font-regular custom-parts-spec-value-color">{val.MFG_ITM_ID}</span>
                                    </span>
                                    <span className="d-block">
                                        <span className="font-14 font-medium custom-parts-spec-color"><Trans>Ordered Date</Trans>:</span> <span className="font-14 font-regular custom-parts-spec-value-color">{val.ORDERED_DATE}</span>
                                    </span>
                                    <span className="d-block">
                                                <span className="font-14 font-medium custom-parts-spec-color"><Trans>Description</Trans>:</span> <span className="font-14 font-regular custom-parts-spec-color" style={{ wordBreak: "break-all" }}>{val.DESCR254}</span>
                                    </span>
                                    {val.SOURCING == "true" ? <div class="w-100 my-2">
                                        <span class="custom-soucring-batch font-12 font-regular py-2 px-3"><Trans>Sent for sourcing</Trans></span>
                                    </div> : ""}
                                </div>
                            </div>
                        </div>
                    )
                })
            }
        }
    }
    /**
     * WAL-1034_PC_13
     * */

    //Ticket No-5614 regression test bug closing the pop up [4/10/2025] - Nachiappan
    handleClose = () => {
        this.props.closePopup(); // Call the closePopup method passed as a prop from the parent 
    };
    render() {

        return (

            <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
                <div className="modal-content" style={{ height: "610px", overflow:"hidden" }}>
                    <div className="modal-header sp-delv-header">
                        <h5 className="modal-title" id="exampleModalLongTitle"><Trans>The following parts have been ordered against</Trans> ({localStorage.getItem("WONum") !== undefined ? JSON.parse(localStorage.getItem("WONum")) : ""})</h5>
                        <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={this.handleClose}>
                            <span aria-hidden="true">×</span>
                        </button>
                    </div>
                    <div className="modal-body orderitem-slim-scroll" >
                        <div className="row">
                            <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                <div className=" px-1">
                                    {/*Order Card starts here*/}
                                    {this.bindWO_Parts()}

                                    {/*Order Card Endss here*/}

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
export default withTranslation()(WOPartsComponent);